import React, { useEffect } from 'react';

import { CustomImage } from '@vw-marketing/us-components';

import { AppConstants } from '../../utils/app-constants';
import { isValidHexColor } from '../../utils/general';
import {
  StyledBackground,
  StyledCardTileHover,
  StyledImagePlaceholder,
  StyledImageWrapper,
} from './styles';

interface CarImageProps {
  backgroundColor: string;
  backgroundImage?: string;
  errorImage: string;
  imageAlt: string;
  imageSrc: string;
  isCustomImage: boolean;
  isIdBuzz?: boolean;
  isNewImage?: boolean;

  onClick?: () => void;
}

export const CarImage: React.FC<CarImageProps> = ({
  backgroundColor,
  backgroundImage,
  errorImage,
  imageAlt,
  imageSrc,
  isCustomImage,
  isIdBuzz,
  isNewImage,
  onClick
}) => {
  // Preload bg image
  useEffect(() => {
    if (backgroundImage) {
      const img = new Image();
      img.src = backgroundImage;
    }
  }, [backgroundImage]);

  return (
    <StyledCardTileHover isNewImage={isNewImage} onClick={onClick}>
      <StyledBackground
        data-bg={isValidHexColor(backgroundColor) ? backgroundColor : '#ccab0d'}
        backgroundColor={
          isValidHexColor(backgroundColor) ? backgroundColor : '#ccab0d'
        }
        backgroundImage={backgroundImage}
        className="background-container"
      >
        <StyledImagePlaceholder className="image-placeholder" isIdBuzz={isIdBuzz}>
          <StyledImageWrapper
            className="image-wrapper"
            isNewImage={isNewImage}
            isCustomImage={isCustomImage}
          >
            <CustomImage
              alt={imageAlt}
              srcPlaceholder={AppConstants.PlaceHolder480x216}
              srcErrorImage={errorImage}
              src={imageSrc}
            />
          </StyledImageWrapper>
        </StyledImagePlaceholder>
      </StyledBackground>
    </StyledCardTileHover>
  );
};
